export function toString(value: string | number | boolean | undefined): string {
  return (value ?? '').toString()
}

